//
// Select the correct build version depending on the environment.
//
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./production.js');
} else {
  module.exports = require('./development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/@dabh/diagnostics/browser/index.js
// module id = 54BT
// module chunks = 0